import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData, putData, updateData, deleteData, activateData } from '../../../apiService'; // Assuming putData is used for updating
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, ListItem } from '@mui/material';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';
import { TextField } from '@mui/material';
import { Discount } from '@mui/icons-material';
import UndoIcon from '@mui/icons-material/Undo';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const SaleExtraOrderEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL
    const recordId = useParams(); // Assuming you're using React Router
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [Quantity, setQuantity] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [customerName, setCustomerName] = useState('');
    const [rate, setRate] = useState('');
    const [discount, setDiscount] = useState(''); // Correct 
    const [singlediscount, setsingleDiscount] = useState(''); // Correct capitalization
    const [GSTRate, setGSTRate] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [tripdate, setTripdate] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [qty, setQty] = useState('');
    const [DiscountPerPiece, setDiscountPerPiece] = useState('');
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [Remarks, setRemarks] = useState("");
    const [SaleRemarks, setSaleRemarks] = useState("");
    const [items, setitems] = useState('');
    const [isReturnsale, setisReturn] = useState('');
    const [Bundle, setBundle] = useState('');
    const [QtyBundle, setQtyBundle] = useState('');

    const [Pieces, setPieces] = useState('');
    const [LastBillDate, setLastBillDate] = useState("");
    const [LastBillAmount, setLastBillAmount] = useState("");
    const [Outstanding, setOutstanding] = useState("");
    const [pricetype, setpricetype] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [pcategoryOptions, setPCategoryOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedPCategory, setSelectedPCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemnameget, setItemName] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [selecteditems, setSelectedItems] = useState("");
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItemsType, setSelectedItemsType] = useState("");
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [formData, setFormData] = useState([]);
    const [Route, setRoute] = useState([]);
    const [itemdata, setData] = useState([]);
    const [tid, setTripId] = useState("");
    const [TripWiseID, setTripWiseID] = useState('');
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();



    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    useEffect(() => {
        fetchData('SaleApi', `/SaleDetails/${id}`, token)
            //fetchData('SaleOrderApi', `/SaleDetails/${id}`, token)
            .then((response) => {
                const array = response.response_data.SaleOrder;
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.SaleOrder);
                    setCustomerId(response.response_data.SaleOrder.CustomerId);
                    setData(response.response_data.SaleOrderDetails);
                    setItemList(response.response_data.SaleOrderDetails);
                    setTripId(response.response_data.SaleOrder.TripId);
                    setTripWiseID(response.response_data.SaleOrder.TripId);
                    setRoute(array.Route)
                    console.log(response.response_data.SaleOrderDetails);
                }
                setFormData((prevData) => ({
                    ...prevData,
                    ModifiedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    const handleSubmit = (event) => {
        event.preventDefault();
        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
        }));
        const CreateData = {
            SaleOrder: formData,
            SaleOrderDetails: itemdata
        };
        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push(`/AddtionalOrderIndex/${id}`);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...itemdata];
            updatedRecords.splice(index, 1);
            setData(updatedRecords);
        }
    };

    //Items
    const fetchItems = async () => {
        try {
            const response = await fetchData('DespatchReport', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Name
                }));
                setItemsrOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleItemsChange = (selectedOption) => {
        setSelectedItemsType(selectedOption);
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const fetchItemData = async () => {
        try {
            const response = await fetchData('SaleOrderApi', `/SaleDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data.SaleOrder); //TripId
                setCustomerId(response.response_data.SaleOrder.CustomerId);
                setData(response.response_data.SaleOrderDetails);
                setItemList(response.response_data.SaleOrderDetails);
                setTripId(response.response_data.Sale.TripId);
                console.log(tid);
            }
            setIsModalOpen(true);
        } catch (error) {
            console.error('Error fetching Item', error);
        }
    };



    //Product catgory
    useEffect(() => {
        const fetchPCategoryTypes = async () => {
            try {
                const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);
                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(pcat => ({
                        value: pcat.id,
                        label: pcat.name
                    }));
                    setPCategoryOptions(options);
                    setPCategoryId(dataArray[0].id);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };
        fetchPCategoryTypes();
    }, [companyId, token]);

    const handlePCategoryChange = (selectedOption) => {

        setSelectedPCategory(selectedOption);
        fetchCategoryTypes(selectedOption.value);
        setPCategoryId(selectedOption.value);
        setSelectedItem(null);
        setSelectedCategory(null);

    };

    //varient
    const fetchCategoryTypes = async (productCategoryId) => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoryOptions(options);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };


    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption);
        fetchItemsTypes(selectedOption.value);
        setCategoryId(selectedOption.value);
        setSelectedItem(null);
    };

    const fetchItemsTypes = async (categoryId) => {
        try {
            const response = await fetchData('ItemApi', `/${companyId}/${categoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };


    const handleItemChange = async (selectedOptions) => {
        setSelectedItem(selectedOptions);
        const ItemID = selectedOptions.value;
        setItemId(ItemID);
        try {
            const response = await fetchData('ItemRateCheckingApi', `/${customerId}/${ItemID}`, token);
            if (response && response.response_data && response.response_data.length > 0) {
                let itemFound = false;
                response.response_data.forEach(category => {
                    if (category.Items && category.Items.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                console.log(`Processing item: ${item.Name}`);
                                const { Rate, GSTRate, Weight, Bundle, QtyBundle } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setBundle(Bundle);
                                setQtyBundle(QtyBundle);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight, // Add weight to the newItem state
                                    rate: Rate,
                                    GSTRate: GSTRate,
                                    //Bundle: Bundle,
                                    Bundle: Bundle ?? 0, // Set Bundle to 0 if it's null
                                    QtyBundle: QtyBundle ?? 0,
                                }));
                                itemFound = true; // Set itemFound to true when an item is processed
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };


    const [newItem, setNewItem] = useState("");



    useEffect(() => {
        const Quantity = parseInt(qty) || 0;
        const gstAmount = (rate * GSTRate) / 100;
        const totalAmount = rate * Quantity;
        const totalPlusGst = totalAmount + gstAmount;
        const bundle = Bundle;

        setNewItem((prevItem) => ({
            ...prevItem,
            Rate: rate,
            totalAmount: totalAmount,
            gstAmount: gstAmount,
            totalPlusGst: totalPlusGst,
            discount: discount, // Ensure correct reference
            Bundle: bundle,
            //pieces: pieceCount,
        }));
    }, [rate, qty, discount, GSTRate, Bundle]); // Added dependencies

    const [itemList, setItemList] = useState([]);

    //dulicate check
    const isDuplicateItem = (itemList, newItem) => {
        return itemList.some(item => item.ItemId === newItem.ItemId);
    };


    const AddtoListdata = (e) => {
        e.preventDefault();
        if (qty > 0) {
            const Quantity = parseInt(qty);
            const DiscountPerPiece = newItem.DiscountPerPiece || 0; // Default to 0 if DiscountPerPiece is null or undefined
            const discount = parseInt(DiscountPerPiece) || 0;
            const bundleSize = parseInt(newItem.Bundle) || 0; // Default to 1 if Bundle is null or 0
            const numBundles = bundleSize ? Math.floor(Quantity / bundleSize) : 0;
            const pieceCount = bundleSize ? Quantity % bundleSize : 0;
            const RatePerKg = rate;
            const isdelete = true;
            let RateAfterDiscount = 0;

            if (discount > 0) {
                RateAfterDiscount = RatePerKg - discount;
            }
            else {
                RateAfterDiscount = rate;
            }
            const TotalQty = newItem.weight * Quantity;
            const totalAmount = RatePerKg * Quantity;
            const TotalAmtperkgwise = RatePerKg * TotalQty;
            const TaxableAmt = ((RateAfterDiscount) * TotalQty * 100) / (100 + GSTRate);
            const GSTAmt = (TaxableAmt * GSTRate) / 100;
            const GstPer = (GSTAmt / TaxableAmt) * 100;
            const NetAmt = TaxableAmt + GSTAmt;

            const updatedItem = {
                ...newItem,
                Item: selectedItem.label,
                // Id: selectedItem.value,
                ItemId: selectedItem.value,
                Quantity: Quantity,
                rate: rate,
                RateAfterDiscount: RateAfterDiscount,
                GSTRate: GSTRate,
                totalAmount: totalAmount,
                NetAmt: NetAmt,
                discount: discount,
                TotalQty: TotalQty,
                RatePerKg: RatePerKg,
                TotalAmtperkgwise: TotalAmtperkgwise,
                TaxableAmt: TaxableAmt,
                GSTAmt: GSTAmt,
                GstPer: GstPer,
                Bundle: numBundles,
                Pieces: pieceCount,
                Isdelete: isdelete,
                QtyBundle: QtyBundle,
            };
            // Check for duplicates
            if (isDuplicateItem(itemList, updatedItem)) {
                alert("This Item already exists in the list.");
                return;
            }
            // Updating state
            setItemList([...itemList, updatedItem]);

            // Resetting newItem state
            setNewItem({
                ItemId: '',
                Name: '',
                Quantity: 1,
                GSTRate: 0,
                rate: 0,
                totalAmount: 0,
                totalPlusGst: 0,
                discount: 0,
                weight: 0,
                TotalQty: 0,
                rateperkg: 0,
                TotalAmtperkgwise: 0,
                GstPer: 0,
                GSTAmt: 0,
                TaxableAmt: 0,
                Bundle: 0,
                pieces: 0,
                RateAfterDiscount: 0,
                Isdelete: 0,
                selectedPCategory,
                selectedCategory,
                selectedItem,
            });

            // Resetting other state variables
            setSelectedItem('');
            setQty('');
            setRate('');
            setGSTRate(0);
            setBundle('');
        }
    };
    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleQuantityChange = (e, index) => {
        const { value } = e.target;
        const updatedItems = [...itemList];
        updatedItems[index].Quantity = parseInt(value, 10);
        let bundleSize = 0;// Default to 1 if Bundle is null or 0

        const DiscountPerPiece = updatedItems[index].DiscountPerPiece || 0;
        const bag = updatedItems[index].BagWeight || 0;
        const bagweight = updatedItems[index].weight || 0;
        let BagWeight = 0;
        if (bag > 0) { //exixting
            BagWeight = bag;
            bundleSize = parseInt(updatedItems[index].BundleAndPiece) || 0;
        }
        else if (bagweight > 0) {
            BagWeight = bagweight;
            bundleSize = parseInt(updatedItems[index].QtyBundle) || 0;

        }
        const numBundles = bundleSize ? Math.floor(value / bundleSize) : 0;
        const pieceCount = bundleSize ? value % bundleSize : 0;
        const TotalQty = BagWeight * value;
        const rateperkg = updatedItems[index].RatePerKg;
        const RateAfterDiscount = rateperkg - DiscountPerPiece;
        const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
        const TotalAmtperkgwise = RateAfterDiscount * TotalQty;
        const TaxableAmt = (((RateAfterDiscount) * TotalQty * 100) / (100 + updatedItems[index].GSTRate));
        // const gstAmount = (totalAmount * updatedItems[index].GSTRate) / 100;
        const GSTAmt = (TaxableAmt * updatedItems[index].GSTRate) / 100;
        const GSTRate = updatedItems[index].GSTRate;
        const GstPer = (GSTAmt / TaxableAmt) * 100;
        const NetAmt = TaxableAmt + GSTAmt;
        updatedItems[index].RateAfterDiscount = RateAfterDiscount;
        updatedItems[index].GSTAmt = GSTAmt;
        updatedItems[index].NetAmt = NetAmt;
        updatedItems[index].DiscountPerPiece = DiscountPerPiece;
        updatedItems[index].TotalQty = TotalQty;
        updatedItems[index].GSTRate = GSTRate;
        updatedItems[index].TaxableAmt = TaxableAmt;
        updatedItems[index].Bundle = numBundles;
        updatedItems[index].Pieces = pieceCount;
        setItemList(updatedItems);
    };
    const handleDiscountChange = (e, index) => {
        const value = e.target.value;
        const updatedItems = [...itemList];
        updatedItems[index].DiscountPerPiece = value === '' ? '' : parseFloat(value) || 0;

        if (value !== '') {
            const TotalQty = updatedItems[index].TotalQty;
            const rateperkg = updatedItems[index].RatePerKg;
            const RateAfterDiscount = rateperkg - updatedItems[index].DiscountPerPiece;
            const totalAmount = updatedItems[index].rate * updatedItems[index].quantity;
            const TotalAmtperkgwise = RateAfterDiscount * TotalQty;
            const TaxableAmt = (((RateAfterDiscount) * TotalQty * 100) / (100 + updatedItems[index].GSTRate));
            const GSTAmt = (TaxableAmt * updatedItems[index].GSTRate) / 100;
            const GSTRate = updatedItems[index].GSTRate;
            const GstPer = (GSTAmt / TaxableAmt) * 100;
            const NetAmt = TaxableAmt + GSTAmt;
            updatedItems[index].RateAfterDiscount = RateAfterDiscount;
            updatedItems[index].GSTAmt = GSTAmt;
            updatedItems[index].NetAmt = NetAmt;
            updatedItems[index].GSTRate = GSTRate;
            updatedItems[index].TaxableAmt = TaxableAmt;
        }
        updatedItems[index].discount = value === '' ? '' : parseFloat(value) || 0;
        setItemList(updatedItems);
    };

    const handleQtyChange = (e) => {
        const input = e.target.value.replace(/\D/g, '');
        if (input.length <= 10) {
            setQty(input); // Update state with cleaned input

            const Quantity = parseInt(input) || 0;

            const gstAmount = (rate * GSTRate) / 100;
            const totalAmount = rate * Quantity;
            const totalPlusGst = totalAmount + gstAmount;
            const totalQuantity = newItem.weight * Quantity;

            // Update state with the new calculated values
            setNewItem((prevItem) => ({
                ...prevItem,
                Quantity: Quantity,
                totalAmount: totalAmount,
                GSTRate: GSTRate,
                gstAmount: gstAmount,
                totalPlusGst: totalPlusGst,

                discount: discount,
                totalQuantity: totalQuantity,
            }));
        }
    };

    const addRecord = async (e) => {
        e.preventDefault();
        let isValid = true;

        itemList.forEach((item) => {
            if (!item.Quantity || item.Quantity <= 0) {
                isValid = false;
            }
        });

        if (!isValid) {
            alert('Please Enter Quantity❗');
            setIsLoading(false);
            return;
        }

        const itemsToSave = itemList.map(item => ({

            ItemId: item.ItemId,
            CustomerId: customerId,
            CompanyId: companyId,
            CategoryId: categoryId,
            ProductCategoryId: productCategoryId,
            Rate: item.Rate,
            Quantity: item.Quantity,
            Discount: item.discount ? item.discount : 0,
            BilledDate: new Date(),
            CreatedBy: userId,
            CreatedDate: new Date(),
            RatePerKg: item.RatePerKg,
            DiscountPerPiece: item.DiscountPerPiece ? item.DiscountPerPiece : 0,
            // RateAfterDiscount: (item.RatePerKg - DiscountPerPiece),
            TotalQty: item.TotalQty,
            BagWeight: item.BagWeight,
            CGSTAmt: (item.GSTAmt / 2),
            SGSTAmt: (item.GSTAmt / 2),
            GSTAmt: item.GSTAmt,
            TaxableAmt: item.TaxableAmt,
            NetAmt: item.NetAmt,
            Bundle: item.Bundle,
            Pieces: item.Pieces

        }));

        const saleorderdata = {

            CustomerId: customerId,
            Id: id,
            SaleRemarks: formData.SaleRemarks,
            CreatedBy: userId,
            CompanyId: companyId,
            orderOrderType: 1,
            CreatedDate: new Date(),
        };

        const updateRecord = {
            SaleOrder: saleorderdata,
            SaleOrderDetails: itemsToSave,
        };
        try {
            const response = await updateData('OrderConfirmedApi', id, updateRecord, token);
            console.log('Record updated successfully:', response);

            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            setQuantity("");
            setSelectedItemsType("");

            fetchItemData();
            window.location.reload();
            setIsModalOpen(true);
        } catch (error) {
            console.error('Error updating record:', error);
        }

    };
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [itemName, setItemNames] = useState('');

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setDeleteItemId(null);
        setItemNames('');
        setConfirmDialogOpen(true);
    };

    const ConfirmDialog = (index, deleteItemId, itemName = '') => {
        setItemToDeleteIndex(null);
        setDeleteItemId(deleteItemId);
        setItemNames(itemName);
        setConfirmDialogOpen(true);
    };


    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
        setDeleteItemId(null);
        setItemNames('');
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);

            closeConfirmDialog();

        }
        else if (deleteItemId !== null) {
            deleteData('OrderConfirmedApi', `${deleteItemId}`, token)
                .then((response) => {
                    fetchData();
                    setDeleteItemId(null);
                    setConfirmDialogOpen(false);

                    //  handleRefreshClick();

                })
                .catch((error) => {
                    console.error('Error deleting record:', error);
                });
        }
        closeConfirmDialog();
       // window.location.reload();
    };



    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto', maxWidth: '98%' }}>
            <style>
                {`
        .container::-webkit-scrollbar {
          width: 0.1em;
        }
        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }
        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
            </style>
            <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ maxWidth: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '550px', overflowY: 'auto' }}>
                <div className="bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginLeft: '-5px', marginTop: '-20px', backgroundColor: 'rgba(255, 255, 255, 0.5)', overflowY: 'auto' }}>
                    <h5 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown', textAlign: 'left', marginTop: '-15px' }}>Sale Order Edit</h5>
                    <div className="flex mb-2" style={{ marginLeft: '500px', marginTop: '-47px', color: '#02395E', fontWeight: 'bolder' }}>
                        <h6 style={{ fontWeight: 'bolder' }}>Route: {Route}</h6>
                    </div>
                    <div className="flex mb-2" style={{ justifyContent: "flex-end", marginTop: '-45px' }}>

                        <Tooltip title="Back To List">
                            <Link to={`/ExtraLoadingSaleIndex/${TripWiseID}`} style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button variant="contained" color="error" style={{ marginLeft: '10px', height: '30px', marginTop: '5px' }}>
                                    Back<ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>

                        {/* </Link> */}
                        &nbsp;&nbsp;

                        <Button onClick={addRecord} style={{ backgroundColor: 'darkgreen', color: 'white', fontWeight: 'bolder', height: '30px', marginTop: '5px' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                        </Button>

                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-4px' }} >
                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="Remarks">
                                Customer
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.CustomerName} type="text" placeholder="" disabled />
                        </div>
                        <div className="w-1/2 mr-2">

                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="Remarks">
                                Remarks
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"

                                name="SaleRemarks"
                                value={formData.SaleRemarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remark"
                                maxLength="100"
                                autoComplete='off'
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex" style={{ marginTop: '-10px' }}>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px' }}>
                                Category
                            </label>
                            <Select
                                value={selectedPCategory}
                                onChange={handlePCategoryChange}
                                options={pcategoryOptions}
                                placeholder="Select Category"
                                isSearchable

                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px', width: '200px' }}>
                                Variant
                            </label>
                            <Select
                                value={selectedCategory}
                                onChange={handleCategoryChange}
                                options={categoryOptions}
                                placeholder="Select Category"
                                isSearchable

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px' }}>
                                Variant with Bagweight
                            </label>
                            <Select
                                value={selectedItem}
                                onChange={handleItemChange}
                                options={itemOptions}
                                placeholder="Select Item"
                                isSearchable

                            />
                        </div>
                        <div className="w-1/8 mr-2" >
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Quantity" style={{ fontSize: '15px' }}>
                                QTY (No.of pieces)

                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={qty}
                                onChange={handleQtyChange}
                                type="text"
                                placeholder="Quantity"
                                style={{ width: '150px', height: '37px' }}
                            />
                        </div>
                        <div className="w-1/7 mr-2">
                            <Button variant="contained" color="primary" onClick={AddtoListdata} style={{ marginTop: '32px', marginLeft: '10px', fontSize: '12px' }}>Add Item</Button>
                        </div>

                    </div>
                    <div className="w-full mb-4 flex">

                        <TableContainer component={Paper}>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className=" text-left text-sm font-medium" style={{ width: '15%', fontWeight: 'bolder' }}>Name</th>
                                        <th className="text-center text-sm font-medium" style={{ width: '10%', fontWeight: 'bolder' }}>Qty
                                            <p style={{ fontSize: '11px', marginBottom: '-10px', textAlign: 'center' }}>(No.of pieces)</p>
                                        </th>
                                        <th className=" text-right text-sm font-medium" style={{ textAlign: 'center', width: '8%', fontSize: '13px', fontWeight: 'bolder' }}>Total Qty
                                            <p style={{ fontSize: '11px', marginBottom: '-10px' }}>(KGS)</p>
                                        </th>
                                        <th className=" text-right text-sm font-medium" style={{ textAlign: 'center', width: '4%', fontWeight: 'bolder' }}>Bundle</th>
                                        <th className=" text-right text-sm font-medium" style={{ textAlign: 'center', width: '4%', fontWeight: 'bolder' }}>Pieces</th>
                                        <th className=" text-right text-sm font-medium" style={{ width: '13%', fontWeight: 'bolder' }}>Rate/Kg
                                            <p style={{ fontSize: '11px', marginBottom: '-10px' }}>(Including Tax)</p>
                                        </th>
                                        <th className=" text-right text-sm font-medium" style={{ width: '3%', fontWeight: 'bolder' }}>Discount</th>
                                        <th className=" text-right text-sm font-medium" style={{ textAlign: 'center', width: '12%', fontWeight: 'bolder' }}>Rate
                                            <p style={{ fontSize: '9px', marginBottom: '-10px' }}>(After Discount)</p>  </th>
                                        <th className=" text-right text-sm font-medium" style={{ width: '11%', textAlign: 'left', fontWeight: 'bolder' }}>Taxable Amt</th>
                                        <th className="text-right text-sm font-medium" style={{ fontWeight: 'bolder' }}>GST%</th>
                                        <th className="px-4 py-2 text-right text-sm font-medium" style={{ width: '13%', fontSize: '12.5px', fontWeight: 'bolder' }}>
                                            GST (₹)
                                        </th>
                                        <th className="text-right text-sm font-medium" style={{ width: '9%', fontWeight: 'bolder' }}>Total</th>
                                        <th className="text-right text-sm font-medium" ></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {itemList.map((invdetail, index) => (
                                        <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>

                                            <td className="border-r" style={{ padding: '8px', fontSize: '14px', width: '15%' }}>{invdetail.Item}</td>
                                            <td className="border-r " style={{ padding: '1px', fontSize: '14px', width: '7%', textAlign: 'center', backgroundColor: invdetail.Quantity > invdetail.BalStock ? '#ffcccc' : 'inherit' }}>
                                                <input
                                                    type="number"
                                                    value={invdetail.Quantity}
                                                    onChange={(e) => handleQuantityChange(e, index)}
                                                    style={{ maxWidth: '120px', textAlign: 'right' }}
                                                    name="Quantity"
                                                    min="0"
                                                    step="1"
                                                />
                                            </td>
                                            <td className=" border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '11%' }}>{invdetail.TotalQty}</td>
                                            <td className=" border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '5%' }}>{invdetail.Bundle}</td>
                                            <td className="border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '5%' }}>{invdetail.Pieces}</td>
                                            <td className="border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '13%' }}>{invdetail.RatePerKg}</td>
                                            <td className="border-r text-right text-sm" style={{ width: '10%' }}>


                                                <input
                                                    type="number"
                                                    value={invdetail.DiscountPerPiece === '' ? '' : (isNaN(invdetail.DiscountPerPiece) || invdetail.DiscountPerPiece === "") ? '0' : invdetail.DiscountPerPiece}
                                                    onChange={(e) => handleDiscountChange(e, index)}
                                                    className="w-full  border rounded text-sm"
                                                    step="0.01"
                                                    min="0"
                                                    style={{ marginLeft: '-20%' }}
                                                />
                                            </td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '12%' }}>
                                                {((invdetail.DiscountPerPiece ?? 0) === 0 ? invdetail.RatePerKg : (invdetail.RatePerKg - invdetail.DiscountPerPiece)).toFixed(2)}</td>
                                            <td className="border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '7%' }}>{invdetail.TaxableAmt.toFixed(2)}</td>
                                            <td className="border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '45%' }}>{invdetail.GSTRate}</td>
                                            <td className="px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '9%' }}>{invdetail.GSTAmt.toFixed(2)}</td>
                                            <td className=" px-4 py-2 border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '9%' }}>{invdetail.NetAmt.toFixed(2)}</td>
                                            <td className="border-r text-right text-sm" style={{ padding: '8px', fontSize: '14px', width: '3%' }}>
                                                {invdetail.Isdelete ? (
                                                    <Tooltip title="Delete">
                                                        <DeleteIcon
                                                            style={{ color: 'violet', cursor: 'pointer', marginLeft: '20px' }}
                                                            onClick={() => openConfirmDialog(index)}
                                                        />
                                                    </Tooltip>
                                                ) :
                                                    <Tooltip>
                                                        <IconButton onClick={() => (invdetail.IsActive ? ConfirmDialog(index, invdetail.Id, invdetail.ItemName) : "")}>
                                                            {invdetail.IsActive ? <DeleteIcon style={{ color: 'violet', marginRight: '-13px' }} /> : ""}
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td className="border-r text-left text-sm" colSpan="1">Total</td>
                                        <td className="border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Quantity, 0)}</td>
                                        <td className="border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.TotalQty, 0)}</td>
                                        <td className="border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Bundle, 0)}</td>
                                        <td className="border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.Pieces, 0)}</td>
                                        <td className=" border-r text-right text-sm">

                                            {itemList.reduce((acc, item) => {
                                                const ratePerKg = Number(item.RatePerKg);
                                                if (!isNaN(ratePerKg)) {
                                                    return acc + ratePerKg;
                                                }
                                                return acc;
                                            }, 0).toFixed(2)}
                                        </td>

                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => {
                                                const singleDiscount = Number(item.DiscountPerPiece) || 0;
                                                return acc + singleDiscount;
                                            }, 0).toFixed(2)}
                                        </td>

                                        <td className="border-r text-right text-sm">
                                            {itemList.reduce((acc, item) => {
                                                const ratePerKg = Number(item.RatePerKg) || 0;
                                                const singleDiscount = Number(item.DiscountPerPiece) || 0;
                                                if (!isNaN(ratePerKg) && !isNaN(singleDiscount)) {
                                                    return acc + (ratePerKg - singleDiscount);
                                                } else {
                                                    return acc;
                                                }
                                            }, 0).toFixed(2)}
                                        </td>

                                        <td className=" border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.TaxableAmt, 0).toFixed(2)}</td>
                                        <td className=" border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.GSTRate, 0).toFixed(2)}</td>
                                        <td className="border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.GSTAmt, 0).toFixed(2)}</td>
                                        <td className=" border-r text-right text-sm">{itemList.reduce((acc, item) => acc + item.NetAmt, 0).toFixed(2)}</td>
                                        <td className="border-r text-right text-sm"></td>
                                    </tr>
                                </tfoot>
                            </table>


                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ⚠️ Are you sure you want to delete  "{itemnameget}" permanently?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={() => handleDelete()}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </TableContainer>
                    </div>

                </div>


            </div>
        </div>
    );
};

export default SaleExtraOrderEdit;
